import { useGraphNode } from '@routes/Panorama/data/panoramaNetwork'
import GroundMarker from '@routes/Panorama/image/GroundMarker'
import { type PanoramaImage } from '@state/panorama'

interface MarkersProps {
  currentPanoramaImage: PanoramaImage
  onImageSelect: (image: PanoramaImage) => void
  domeRadius: number
}

function GroundMarkers({ currentPanoramaImage, onImageSelect, domeRadius }: MarkersProps) {
  const currentNode = useGraphNode(currentPanoramaImage)
  if (!currentNode) return null

  return (
    <>
      {currentNode.connectedPoints.map(image => (
        <GroundMarker
          onClick={() => onImageSelect(image)}
          key={image.id}
          panoramaImage={image}
          currentPanoramaImage={currentPanoramaImage}
          domeRadius={domeRadius}
        />
      ))}
    </>
  )
}

export default GroundMarkers